import _defineProperty from "/home/runner/work/contribute/contribute/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Box, Spinner } from '.';

var TextInputInnerVisualSlot = function TextInputInnerVisualSlot(_ref) {
  var children = _ref.children,
      hasLoadingIndicator = _ref.hasLoadingIndicator,
      showLoadingIndicator = _ref.showLoadingIndicator,
      visualPosition = _ref.visualPosition;

  if (!children && !hasLoadingIndicator || visualPosition === 'leading' && !children && !showLoadingIndicator) {
    return null;
  }

  if (!hasLoadingIndicator) {
    return /*#__PURE__*/React.createElement("span", {
      className: "TextInput-icon"
    }, children);
  }

  return /*#__PURE__*/React.createElement("span", {
    className: "TextInput-icon"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    position: "relative"
  }, children && /*#__PURE__*/React.createElement(Box, {
    sx: {
      visibility: showLoadingIndicator ? 'hidden' : 'visible'
    }
  }, children), /*#__PURE__*/React.createElement(Spinner, {
    sx: children ? _objectSpread({
      position: 'absolute',
      top: 0,
      height: '100%',
      maxWidth: '100%',
      visibility: showLoadingIndicator ? 'visible' : 'hidden'
    }, visualPosition === 'leading' ? {
      left: 0
    } : {
      right: 0
    }) : {
      visibility: showLoadingIndicator ? 'visible' : 'hidden'
    },
    size: children ? undefined : 'small'
  })));
};

TextInputInnerVisualSlot.displayName = "TextInputInnerVisualSlot";
export default TextInputInnerVisualSlot;